import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n/index'
import Snotify, {SnotifyPosition} from 'vue-snotify';
import AppUtils from './plugins/AppUtils'
import {startFirebase} from './utils/FirebaseApp'

import {isDevEnv, isIntersectionObserver, isProdEnv, isServiceWorker} from './utils/Utils'
import ActionCableVue from 'actioncable-vue';


Vue.use(ActionCableVue, {
    debug: isDevEnv(),
    debugLevel: isProdEnv() ? 'error' : 'all',
    connectionUrl: isProdEnv() ? `wss://${document.location.hostname}/cable` : 'ws://localhost:3000/cable'
});

Vue.config.productionTip = false;
//Vue.config.performance = process.env.NODE_ENV !== "production";

Vue.use(Snotify, {
    toast: {
        position: SnotifyPosition.rightTop,
        titleMaxLength: 1000,
        bodyMaxLength: 3000
    }
});
Vue.use(AppUtils);

if (isServiceWorker()) {
    window.addEventListener('load', () =>
        navigator.serviceWorker.register('/sw.js')
            .then(registration => console.log('Registrou SW', registration))
            .catch(err => console.error('SW Falou no Registro', err)));

    startFirebase();
}

if (!isIntersectionObserver()) {
    const intersect = document.createElement('script');
    intersect.setAttribute('src', `${isProdEnv() ? '/assets' : ''}/javascript/intersection-observer.min.js`);
    document.head.appendChild(intersect);
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
